import { useState, useEffect } from 'react';
export const useMediaQuery = ({ query }) => {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const resizeListener = () => setMatches(media.matches);
        window.addEventListener('resize', resizeListener);
        return () => window.removeEventListener('resize', resizeListener);
    }, [matches, query]);
    return matches;
};
